import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../../config";

export const quizCoreApi = createApi({
  reducerPath: "quizCoreApi",

  baseQuery: fetchBaseQuery({
    baseUrl: config.BASE_API,
  }),

  endpoints: (builder) => ({
    userRegiser: builder.mutation({
      query: (payload) => ({
        url: "/user/jra/register",
        method: "POST",
        body: { ...payload },
      }),
    }),
    userOtpVerify: builder.mutation({
      query: (payload) => ({
        url: "user/jra/verify",
        method: "POST",
        body: { ...payload },
      }),
    }),
    quizSubmit: builder.mutation({
      query: (payload) => ({
        url: "/jra/analyse",
        method: "POST",
        body: { ...payload },
      }),
    }),
    analysisGet: builder.mutation({
      query: (payload) => ({
        url: "/jra/get",
        method: "POST",
        body: { ...payload },
      }),
    }),
    checkpointUpdate: builder.mutation({
      query: (payload) => ({
        url: "jra/checkpoint",
        method: "POST",
        body: { ...payload },
      }),
    }),
  }),
});

export const {
  useUserRegiserMutation,
  useUserOtpVerifyMutation,
  useQuizSubmitMutation,
  useAnalysisGetMutation,
  useCheckpointUpdateMutation,
} = quizCoreApi;
